module.exports = __webpack_public_path__ + "assets/img/13-18.c31c8826.svg";